'use client';

import { Empty, Rate } from 'antd';
import clsx from 'clsx';
import React, { useState } from 'react';
import ProductevaluateList from './ProductevaluateList';

type Props = {
  iframeSrc2?: string;
  product?: any;
};

function pickReviewText(item: Record<string, unknown>) {
  const v =
    item.content ??
    item.body ??
    item.evaluate_content ??
    item.comment ??
    item.text;
  return typeof v === 'string' ? v : '';
}



export default function ProductImageShow2({ iframeSrc2, product }: Props) {
  const [activeKey, setActiveKey] = useState('1');
  const tabItems: { key: string; label: string; children: React.ReactNode }[] = [
    {
      key: '1',
      label: '3D模型预览',
      children: (
        <div className="">
          {iframeSrc2 ? (
            <iframe
              src={iframeSrc2}
              className="h-[800px] w-full border-0 overflow-hidden"
              title="国创零部件库-3D模型预览"
            />
          ) : (
            <div className="flex h-[800px] w-full items-center justify-center bg-[#fafafa] text-[#999]">
              暂无3D模型预览
            </div>
          )}
        </div>
      ),
    },
    {
      key: '2',
      label: '产品详情',
      children: (
        <div className="h-[800px] overflow-y-auto py-2">
          {product?.intro ? (
            <div
              className="text-[#333] leading-relaxed [&_img]:max-w-full"
              dangerouslySetInnerHTML={{ __html: product.intro }}
            />
          ) : (
            <Empty description="暂无产品详情" />
          )}
        </div>
      ),
    },
    {
      key: '3',
      label: '评价晒单',
      children: (
        <ProductevaluateList />

      ),
    },
  ];

  const activePanel = tabItems.find((t) => t.key === activeKey) ?? tabItems[0];

  return (
    <div className="product-detail-embed-tabs mt-4 w-full bg-white px-2 pt-2">
      <div
        role="tablist"
        aria-orientation="horizontal"
        className="mb-0 flex flex-wrap gap-6 border-b border-[#f0f0f0]"
      >
        {tabItems.map((tab) => {
          const selected = tab.key === activeKey;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              id={`product-embed-tab-${tab.key}`}
              aria-selected={selected}
              aria-controls={`product-embed-panel-${tab.key}`}
              tabIndex={selected ? 0 : -1}
              onClick={() => setActiveKey(tab.key)}
              className={clsx(
                'relative -mb-px border-0 bg-transparent p-3  text-base leading-none outline-none transition-colors',
                selected
                  ? 'font-medium text-main after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:rounded-sm after:bg-main'
                  : 'text-[#666] hover:text-[#333]',
              )}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      <div
        role="tabpanel"
        id={`product-embed-panel-${activePanel.key}`}
        aria-labelledby={`product-embed-tab-${activePanel.key}`}
        className="pt-2"
      >
        {activePanel.children}
      </div>
    </div>
  );
}
